/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers';
import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { PromiseOrValue } from '../../common';
import type {
  MerkleOrderbookFactory,
  MerkleOrderbookFactoryInterface,
} from '../../MerkleOrderBookFactory.sol/MerkleOrderbookFactory';

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_cashToken',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_cashWallet',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_policyWallet',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_orderBookRouter',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [],
    name: 'NotOwner',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'orderBookAddress',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'blockNumber',
        type: 'uint256',
      },
    ],
    name: 'NewOrderBook',
    type: 'event',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'allOrderBooks',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'cashToken',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'cashWallet',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'string',
            name: 'policyName',
            type: 'string',
          },
          {
            internalType: 'string',
            name: 'policySymbol',
            type: 'string',
          },
          {
            internalType: 'address',
            name: 'firstOwner',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'startDate',
            type: 'uint256',
          },
          {
            internalType: 'uint256[]',
            name: 'guranteedPayouts',
            type: 'uint256[]',
          },
          {
            internalType: 'uint256[]',
            name: 'nonGuranteedPayouts',
            type: 'uint256[]',
          },
        ],
        internalType: 'struct NewPolicyReq',
        name: 'req',
        type: 'tuple',
      },
    ],
    name: 'newPolicyWithOrderBook',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'orderBookRouter',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'policyWallet',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
];

const _bytecode =
  '0x61012060405234801561001157600080fd5b506040516108fc3803806108fc83398101604081905261003091610073565b336080526001600160a01b039384166101005291831660c052821660e0521660a0526100c7565b80516001600160a01b038116811461006e57600080fd5b919050565b6000806000806080858703121561008957600080fd5b61009285610057565b93506100a060208601610057565b92506100ae60408601610057565b91506100bc60608601610057565b905092959194509250565b60805160a05160c05160e051610100516107de61011e6000396000818160ff01526102840152600061012601526000818161017401526102a60152600061014d01526000818160d801526101e501526107de6000f3fe608060405234801561001057600080fd5b506004361061007d5760003560e01c8063a72246871161005b578063a7224687146100fa578063b223642114610121578063ccbb65ab14610148578063f00e51451461016f57600080fd5b8063472c6670146100825780635091f6be146100be5780638da5cb5b146100d3575b600080fd5b610095610090366004610487565b610196565b60405173ffffffffffffffffffffffffffffffffffffffff909116815260200160405180910390f35b6100d16100cc3660046104a0565b6101cd565b005b6100957f000000000000000000000000000000000000000000000000000000000000000081565b6100957f000000000000000000000000000000000000000000000000000000000000000081565b6100957f000000000000000000000000000000000000000000000000000000000000000081565b6100957f000000000000000000000000000000000000000000000000000000000000000081565b6100957f000000000000000000000000000000000000000000000000000000000000000081565b600081815481106101a657600080fd5b60009182526020909120015473ffffffffffffffffffffffffffffffffffffffff16905081565b3373ffffffffffffffffffffffffffffffffffffffff7f0000000000000000000000000000000000000000000000000000000000000000161461023c576040517f30cd747100000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b600080546040517f9363888600000000000000000000000000000000000000000000000000000000815273__$c291e727e7e9ec913b1dc491874823b413$__9163908c15f1917f0000000000000000000000000000000000000000000000000000000000000000917f00000000000000000000000000000000000000000000000000000000000000009173__$598b0d628c403227ee15be19bc57eef674$__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';

type MerkleOrderbookFactoryConstructorParams =
  | [linkLibraryAddresses: MerkleOrderbookFactoryLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MerkleOrderbookFactoryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === 'string' ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    '_isInterface' in xs[0]
  );
};

export class MerkleOrderbookFactory__factory extends ContractFactory {
  constructor(...args: MerkleOrderbookFactoryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(_abi, MerkleOrderbookFactory__factory.linkBytecode(linkLibraryAddresses), signer);
    }
    this.contractName = 'MerkleOrderbookFactory';
  }

  static linkBytecode(linkLibraryAddresses: MerkleOrderbookFactoryLibraryAddresses): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$c291e727e7e9ec913b1dc491874823b413\\$__', 'g'),
      linkLibraryAddresses['contracts/OrderBookFactoryLib.sol:OrderBookFactoryLib'].replace(/^0x/, '').toLowerCase()
    );

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$598b0d628c403227ee15be19bc57eef674\\$__', 'g'),
      linkLibraryAddresses['contracts/NewPolicyLib.sol:NewPolicyLib'].replace(/^0x/, '').toLowerCase()
    );

    return linkedBytecode;
  }

  override deploy(
    _cashToken: PromiseOrValue<string>,
    _cashWallet: PromiseOrValue<string>,
    _policyWallet: PromiseOrValue<string>,
    _orderBookRouter: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<MerkleOrderbookFactory> {
    return super.deploy(
      _cashToken,
      _cashWallet,
      _policyWallet,
      _orderBookRouter,
      overrides || {}
    ) as Promise<MerkleOrderbookFactory>;
  }
  override getDeployTransaction(
    _cashToken: PromiseOrValue<string>,
    _cashWallet: PromiseOrValue<string>,
    _policyWallet: PromiseOrValue<string>,
    _orderBookRouter: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_cashToken, _cashWallet, _policyWallet, _orderBookRouter, overrides || {});
  }
  override attach(address: string): MerkleOrderbookFactory {
    return super.attach(address) as MerkleOrderbookFactory;
  }
  override connect(signer: Signer): MerkleOrderbookFactory__factory {
    return super.connect(signer) as MerkleOrderbookFactory__factory;
  }
  static readonly contractName: 'MerkleOrderbookFactory';

  public readonly contractName: 'MerkleOrderbookFactory';

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MerkleOrderbookFactoryInterface {
    return new utils.Interface(_abi) as MerkleOrderbookFactoryInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): MerkleOrderbookFactory {
    return new Contract(address, _abi, signerOrProvider) as MerkleOrderbookFactory;
  }
}

export interface MerkleOrderbookFactoryLibraryAddresses {
  ['contracts/OrderBookFactoryLib.sol:OrderBookFactoryLib']: string;
  ['contracts/NewPolicyLib.sol:NewPolicyLib']: string;
}
